import { render, staticRenderFns } from "./caifeng.vue?vue&type=template&id=a3361b6a"
import script from "./caifeng.vue?vue&type=script&lang=js"
export * from "./caifeng.vue?vue&type=script&lang=js"
import style0 from "./caifeng.vue?vue&type=style&index=0&id=a3361b6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports